<!--
  대시보드 종합
  시스템 이벤트 위젯

  @since: 2018-06-28
  @author: mk.ko

  * 2019-01-31 현재 사용안함.
-->

<template>
  <div class="widget-wrapper pad0">
    <event-grid :slim="true"
                :height="251"
                :tableData="tableData"></event-grid>
  </div>
</template>

<script>
  // Mixin 객체
  import { widgetMixin } from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import { createNamespacedHelpers } from 'vuex'
  // 스토어 헬퍼 객체
  const { mapActions } = createNamespacedHelpers('dashboard/dashboard')

  import EventGrid from '~/components/grids/eventGrid'

  export default {
    name: 'widgetSystemEvent',
    components: {
      EventGrid
    },
    mixins: [ widgetMixin ],
    data () {
      return {
        w: 3,
        title: 'widgetSystemEvent',
        isLock: false,
        isMove: true,
        isResize: true,
        isMaximum: true,
        eventBus: true,
        tableData: []
      }
    },
    computed: {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      makeSampleData () {
        // 리턴할 리스트
        let realtimeData = []
        // 샘플 허용 호스트 주소
        const sampleType = [
          `CPU ${this.$t('cmn.limit')}`, `MEM ${this.$t('cmn.limit')}`, `HDD ${this.$t('cmn.limit')}`
        ]
        // 샘플 데이터 생성
        for (let i = 0; i < 10; i++) {
          const level = Math.floor(Math.random() * 5)
          const type = sampleType[Math.floor(Math.random() * 10 % sampleType.length)]
          const value = Math.floor(Math.random() * 100)
          const msg = level > 0 ? `Prism 장비의 ${type}가 초과 되었습니다.` : `Prism 장비의 ${type}가 정상화 되었습니다. (현재값: ${value})`
          realtimeData.push({
            level: level,
            startdate: new Date().getTime() - Math.floor(Math.random() * 1000 * 60 * 60),
            deviceName: `BlackSwan_${Math.floor(Math.random() * 100)}`,
            deviceGroup: `Group_${Math.floor(Math.random() * 100)}`,
            type: type,
            msg: msg
          })
        }
        return realtimeData
      },
      async getWidgetContentsData () {
        // Progress 출력 여부
        this.showProgress(true)

        // TODO: 로그 모니터링 연동 부분 (추후)
        // const secRealtimeThreat = await this.getWidgetData('system_event_log', 0)
        this.tableData = this.makeSampleData()

        // Progress 출력 여부
        // this.showProgress(false)
        setTimeout(() => { this.showProgress(false) }, 1500)
      }
    }
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
    position: relative;
  }

  .widget-contents-option {
    z-index: 10;
    right: 0;
    display: flex;
    position: absolute;
    padding-top: 5px;
    padding-right: 5px;
  }

  .widget-contents-option select {
    width: 70px;
    height: 25px;
    font-size: 10pt;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
